<template>
    <section class="limiter-content pa-2 pa-lg-0">
        <div class="padding-block"></div>

        <page-title :eyebrow="$root.user && Number($root.user.type) === 2 ? 'ÁREA DO PROCURADOR' : 'ÁREA DO CREDOR'" :icon="$root.user && Number($root.user.type) === 2 ? 'mdi-briefcase-account-outline' : 'mdi-account-circle-outline'" title="Novo pedido de" highlight="habilitação ou divergência" />

        <div v-html="!user ? dataset.contentUserAnonymous : dataset.contentUserLogged"></div>

        <v-form v-if="user" class="pt-10" ref="form" v-model="dataForm.validForm">
            <procurator-creditor-selector
                v-model="selectedCreditorId"
                :client-id="dataset.data.client"
                :require-client="true"
                allow-pending
                @selected="onCreditorSelected">
            </procurator-creditor-selector>

            <v-alert v-if="isProcurator && selectedCreditor && Number(selectedCreditor.status) === 0" type="warning" text dense>
                A procuração deste credor ainda está em análise pela Administração Judicial. O pedido será apresentado em caráter provisório.
            </v-alert>


            <p class="font-weight-bold">Você gostaria de habilitar ou divergir de um crédito relacionado a qual empresa?
            </p>

            <v-row>
                <v-col cols="12" sm="12">
	                    <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.clients"
	                        label="Selecione a devedora" v-model="dataset.data.client" item-value="id" item-text="name"
	                        :rules="[$rules.required]" outlined hide-details="auto" @change="onClientChange">
	                    </v-autocomplete>
                </v-col>
            </v-row>

            <!-- Prazo de hab/div encerrado: o pedido fecha para todas as classes; o credito vem pela CHC -->
            <v-alert v-if="habdivClosed" type="info" text class="mt-4">
                <strong>{{ selectedClient && selectedClient.chc_open ? 'O prazo de habilitação e divergência deste caso terminou.' : 'O prazo de habilitação e divergência deste caso não está aberto.' }}</strong>
                <template v-if="selectedClient && selectedClient.chc_open">
                    Se você tem crédito reconhecido em outro processo (por exemplo, numa reclamatória trabalhista), envie a
                    <strong>Certidão de Habilitação de Crédito (CHC)</strong> emitida pelo juízo de origem.
                    <div class="mt-3">
                        <v-btn depressed color="primary" :to="{ path: '/certidoes-credito/nova', query: { client_id: selectedClient.id } }">
                            <v-icon left small>mdi-file-certificate-outline</v-icon> Enviar CHC
                        </v-btn>
                    </div>
                </template>
            </v-alert>

            <template v-if="dataset.data.client && !habdivClosed">

                <template>

                    <v-row class="justify-start">
                        <v-col cols="12">
                            <span tabindex="0" class="mr-3"> <strong >Possui ação judicial em andamento ou com trânsito em julgado certificado?</strong></span>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small :color="'primary'" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                                </template>
                                <span>Caso possua uma ação judicial em andamento, marque "SIM" e preencha os dados abaixo</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="12" class="mt-n7">
                            <v-radio-group v-model="dataset.data.actionProgress">
                                <v-radio aria-label="Selecionado sim" label="Sim" :value="true"></v-radio>
                                <v-radio aria-label="Selecionado não" label="Não" :value="false"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <template v-if="dataset.data.actionProgress === true">
                        <!-- <div v-for="(process, index) in processes" :key="index"> -->
                            <div v-for="(process, index) in processes" :key="process.id || `process-${index}`">    
                            <v-row class="mt-n5">
                            <v-col cols="5" sm="5">
                                <v-text-field aria-label="Digite o numero do processo"
                                :disabled="dataset.loading" 
                                dense 
                                required 
                                label="Número do processo"
                                :rules="[$rules.required]" 
                                v-model="process.number" 
                                outlined 
                                hide-details="auto">
                                </v-text-field>
                            </v-col>
                        
                            <v-col cols="3" sm="3">
                                <v-autocomplete aria-label="Selecione o estado de tramitação do processo"
                                :disabled="dataset.loading" 
                                dense 
                                required 
                                :items="dataset.statesList"
                                label="Local de tramitação" 
                                v-model="process.local" 
                                item-value="name"
                                item-text="name" 
                                :rules="[$rules.required]" 
                                outlined 
                                hide-details="auto">
                                </v-autocomplete>
                            </v-col>
                        
                            <v-col cols="4" sm="4">
                                <v-autocomplete aria-label="Selecione o tribunal de tramitação do processo"
                                :disabled="dataset.loading" 
                                dense 
                                :items="dataset.courtList"
                                label="Tribunal de tramitação" 
                                v-model="process.court"
                                item-value="name" 
                                item-text="name" 
                                outlined 
                                hide-details="auto">
                                </v-autocomplete>
                            </v-col>
                        
                            <v-col cols="12" sm="12" class="d-flex justify-end mt-n2">
                                                        
                                <!-- Remove Button -->  
                                <v-tooltip v-if="processes.length > 1" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" @click="removeProcess(index)" color="#E57373" dark x-small aria-label="Botão para remover linha de processo">
                                            <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Remover linha de dados</span>
                                </v-tooltip>

                                <!-- ADD Button --> 
                                <v-tooltip v-if="processes.length < 10 && index === processes.length - 1" bottom>
                                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                    <v-btn class='ml-2' v-bind="tooltipAttrs" v-on="tooltipOn" @click="addProcess" color="green" dark x-small aria-label="Botão para adicionar linha de processo">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Adicionar linha de dados</span>
                                </v-tooltip>  
                            </v-col>
                            </v-row>
                            <br>
                        </div>
                    </template>

                    <!-- <v-row>
                        <v-col v-if="!dataset.loading">
                            <div class="d-flex align-center">
                                <h3 class="mr-5"><strong>Negócios</strong></h3>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                        <v-btn v-bind="tooltipAttrs" v-on="tooltipOn" @click="addItem" color="green" dark x-small aria-label="Botão para adicionar um novo negócio">
                                            Adicionar <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Adicionar um novo negócio</span>
                                </v-tooltip>
                            </div>
                        </v-col>
                    </v-row> -->
                
                </template>

                <v-row>
                    <v-col>
                        <strong>Negócios</strong>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <p v-if="!dataset.loading">
                            Para adicionar um novo negócio,
                            <a href="#" @click.prevent="addItem"><strong>clique aqui</strong></a>
                        </p>
                    </v-col>
                </v-row>
            </template>

            <div v-for="(item, i) in dataset.data.items" :key="i">
                <v-row>
                    <v-col>
                        <strong>Negócio #{{ getItemNumber(i) }}</strong>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <div>
                                        <strong>Origem: </strong>
                                        <span>{{
                                            truncateText(item.origin || 'N/A', 10)
                                            }}</span>
                                        /
                                        <strong>Valor: </strong>
                                        <span v-if="item.amount">{{
                                            item.currency
                                            | enum(
                                                dataset.currencyTypes,
                                                'id',
                                                'currencyFormat'
                                            )
                                            }}
                                            {{ item.amount | currency }}</span><span v-else>N/A</span>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Informe a origem do negócio</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Digite o motivo que gerou os valores do negócio</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
	                                    <v-row>
	                                        <v-col>
	                                            <v-text-field :disabled="dataset.loading" dense label="Origem do negócio"
	                                                v-model="item.origin" required :rules="[$rules.required]" outlined
	                                                hide-details="auto">
	                                            </v-text-field>
	                                        </v-col>
	                                    </v-row>
	                                    <template v-if="debtorCompanyOptions.length">
	                                        <v-row>
	                                            <v-col cols="12">
	                                                <span class="mr-3"> <strong>Informe a empresa relacionada ao crédito</strong></span>
	                                            </v-col>
	                                        </v-row>
	                                        <v-row>
	                                            <v-col cols="12">
	                                                <v-select :disabled="dataset.loading" dense
	                                                    :items="debtorCompanyOptions" label="Empresa devedora"
	                                                    v-model="item.company_name" item-value="name" item-text="name"
	                                                    outlined hide-details="auto" :rules="[$rules.required]">
	                                                </v-select>
	                                            </v-col>
	                                        </v-row>
	                                    </template>
	                                    <v-row>
	                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Informe a moeda e o valor referente ao
                                                    negócio</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Informe o tipo de moeda e o valor devido</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select :disabled="dataset.loading" dense id="type"
                                                :items="dataset.currencyTypes" label="Selecione uma moeda"
                                                v-model="item.currency" item-value="id" item-text="name" outlined
                                                hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-currency-field :disabled="dataset.loading" label="Valor" dense
                                                v-model="item.amount" :allowNegative="false" hide-details="auto"
                                                outlined required :rules="[$rules.required]">
                                            </v-currency-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Informe a sua classe no processo</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Selecione a sua classe no processo</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select dense :items="selectCreditorTypes()" label="Classe"
                                                v-model="item.type" item-value="id" item-text="name" outlined
                                                hide-details="auto" :rules="[$rules.required]">
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <!-- DOCS COMPROBATÓRIOS -->

                                    <v-row>
                                        <v-col cols="12" lg="12">
                                            <p>
                                                <strong>Adicione documentos comprobatórios
                                                    do negócio</strong>
                                            </p>

                                            <v-stepper v-model="item.step" vertical flat>

                                                <!-- STEP 1 -->
                                                <v-stepper-step :complete="item.step > 1" step="1">

                                                    <v-row no-gutters justify='center'>
                                                        <v-col cols='11'>
                                                            <h4>Petição <span
                                                                    class='font-weight-light mr-10'>(opcional)</span>
                                                            </h4>
                                                            <small>Realize o envio da Petição</small>
                                                        </v-col>

                                                        <v-col cols='1'>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon small
                                                                        :color="item.step === 1 ? 'primary' : ''"
                                                                        v-bind="attrs"
                                                                        v-on="on">mdi-help-circle</v-icon>
                                                                </template>
                                                                <span>Informação sobre a Petição</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-stepper-step>

                                                <v-stepper-content step="1">

                                                    <v-text-field :disabled="dataset.loading" hide-details="auto"
                                                        prepend-icon="mdi-paperclip" outlined class='mt-1' dense
                                                        @click:clear="clearDocs(i, 5)" :clearable="true"
                                                        :value="getDocsByType(i, 5)" label="Petição"
                                                        @click.prevent="openDocumentModal(i, 5)">
                                                    </v-text-field>
                                                    <v-btn class='mt-3' color="primary" @click="onInput(i, 1)"
                                                        :disabled="!hasDocument(i, 5, false)">
                                                        Próximo
                                                    </v-btn>
                                                    <v-btn class='ml-3 mt-3' @click="onCancel(i, 1)" text>
                                                        Cancelar
                                                    </v-btn>
                                                </v-stepper-content>

                                                <!-- STEP 2 -->
                                                <v-stepper-step :complete="item.step > 2" step="2">

                                                    <v-row no-gutters justify='center'>
                                                        <v-col cols='11'>
                                                            <h4> Procuração <span
                                                                    class='font-weight-light mr-5'>(opcional)</span>
                                                            </h4>
                                                            <small>Realize o envio da
                                                                Procuração</small>
                                                        </v-col>

                                                        <v-col cols='1'>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon small
                                                                        :color="item.step === 2 ? 'primary' : ''"
                                                                        v-bind="attrs"
                                                                        v-on="on">mdi-help-circle</v-icon>
                                                                </template>
                                                                <span>Informação sobre a Procuração</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-stepper-step>

                                                <v-stepper-content step="2">

                                                    <v-text-field :disabled="dataset.loading" readonly
                                                        hide-details="auto" prepend-icon="mdi-paperclip"
                                                        label="Procuração" outlined class='mt-1' dense :clearable="true"
                                                        @click:clear="clearDocs(i, 2)"
                                                        @click.prevent="openDocumentModal(i, 2)"
                                                        :value="getDocsByType(i, 2)">

                                                    </v-text-field>
                                                    <v-btn class='mt-3' color="primary" @click="onInput(i, 2)"
                                                        :disabled="!hasDocument(i, 2, false)">
                                                        Próximo
                                                    </v-btn>
                                                    <v-btn class='ml-3 mt-3' @click="onCancel(i, 2)" text>
                                                        Cancelar
                                                    </v-btn>
                                                </v-stepper-content>

                                                <!-- STEP 3 -->
                                                <v-stepper-step :complete="item.step > 3" step="3">

                                                    <v-row no-gutters justify='center'>
                                                        <v-col cols='11'>
                                                            <h4> Planilha de Cálculos <span
                                                                    class='font-weight-light'>(opcional)</span></h4>
                                                            <small>Realize o envio da Planilha de
                                                                Cálculos</small>
                                                        </v-col>

                                                        <v-col cols='1'>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon small
                                                                        :color="item.step === 3 ? 'primary' : ''"
                                                                        v-bind="attrs"
                                                                        v-on="on">mdi-help-circle</v-icon>
                                                                </template>
                                                                <span>Informação sobre a Planilha de Cálculos</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>

                                                </v-stepper-step>

                                                <v-stepper-content step="3">

                                                    <v-text-field :disabled="dataset.loading" readonly
                                                        hide-details="auto" prepend-icon="mdi-paperclip" outlined
                                                        class='mt-1' dense @click:clear="clearDocs(i, 6)"
                                                        :clearable="true" :value="getDocsByType(i, 6)"
                                                        label="Planilha de Cáculos"
                                                        @click.prevent="openDocumentModal(i, 6)" />

                                                    <v-btn class='mt-3' color="primary" @click="onInput(i, 3)"
                                                        :disabled="!hasDocument(i, 6, false)">
                                                        Próximo
                                                    </v-btn>
                                                    <v-btn class='ml-3 mt-3' @click="onCancel(i, 3)" text>
                                                        Cancelar
                                                    </v-btn>
                                                </v-stepper-content>

                                                <!-- STEP 4 -->
                                                <v-stepper-step :complete="item.step > 4" step="4">


                                                    <v-row no-gutters justify='center'>
                                                        <v-col cols='11'>
                                                            <h4>Documentos Comprobatórios <span
                                                                    class='font-weight-light'>(obrigatório)</span></h4>
                                                            <small>Realize o envio de Documentos Comprobatórios</small>
                                                        </v-col>

                                                        <v-col cols='1'>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon small
                                                                        :color="item.step === 4 ? 'primary' : ''"
                                                                        v-bind="attrs"
                                                                        v-on="on">mdi-help-circle</v-icon>
                                                                </template>
                                                                <span>Informação sobre os Documentos
                                                                    Comprobatórios</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-stepper-step>

                                                <v-stepper-content step="4">

                                                    <v-text-field :disabled="dataset.loading" readonly
                                                        hide-details="auto" prepend-icon="mdi-paperclip"
                                                        :clearable="true" @click:clear="clearDocs(i, 3)"
                                                        label="Documentos Comprobatórios"
                                                        @click.prevent="openDocumentModal(i, 3)" outlined class="mt-1"
                                                        dense :value="getDocsByType(i, 3)" :rules="[$rules.required]" />

                                                    <v-btn class='mt-3' color="primary" @click="onInput(i, 4)"
                                                        :disabled="!hasDocument(i, 3, true)">
                                                        Próximo
                                                    </v-btn>
                                                    <v-btn class='ml-3 mt-3' @click="onCancel(i, 4)" text>
                                                        Cancelar
                                                    </v-btn>
                                                </v-stepper-content>

                                                <!-- STEP 5 -->
                                                <v-stepper-step step="5">

                                                    <v-row no-gutters justify='center'>
                                                        <v-col cols='11'>
                                                            <h4> Outros <span
                                                                    class='font-weight-light'>(opcional)</span></h4>
                                                            <small>Caso tenha mais documentos, faça o envio</small>
                                                        </v-col>

                                                        <v-col cols='1'>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon small
                                                                        :color="item.step === 5 ? 'primary' : ''"
                                                                        v-bind="attrs"
                                                                        v-on="on">mdi-help-circle</v-icon>
                                                                </template>
                                                                <span>Informação sobre Outros documentos</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-stepper-step>

                                                <v-stepper-content step="5">

                                                    <v-text-field :disabled="dataset.loading" readonly label="Outros"
                                                        prepend-icon="mdi-paperclip" :clearable="true"
                                                        @click:clear="clearDocs(i, 4)" hide-details="auto"
                                                        @click.prevent="openDocumentModal(i, 4)" outlined class="mt-1"
                                                        dense :value="getDocsByType(i, 4)">
                                                    </v-text-field>

                                                    <v-btn class='mt-3' @click="onCancel(i, 5)" text>
                                                        Cancelar
                                                    </v-btn>

                                                </v-stepper-content>
                                            </v-stepper>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <p>
                                                <strong>Informe uma observação referente ao
                                                    negócio</strong>
                                            </p>
                                            <v-textarea :disabled="dataset.loading" dense id="description"
                                                label="Informações Adicionais" :rules="[
                                                    $rules.maxlength(
                                                        item.observation,
                                                        500
                                                    )
                                                ]" counter="500" v-model="item.observation" outlined
                                                hide-details="auto" rows="2" auto-grow></v-textarea>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <v-btn color="primary" text :loading="dataset.loading"
                                                @click.native="removeItem(i)">
                                                <v-icon> mdi-delete-outline </v-icon>
                                                Excluir</v-btn>
                                        </v-col>
                                    </v-row>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-divider></v-divider>
                    </v-col>
                </v-row>
            </div>

            <v-row>
                <!-- <v-col>
                    <v-btn color="primary" :loading="dataset.loading" @click.native="save">Salvar</v-btn>
                </v-col> -->

                <v-col>
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn v-on="on" color="primary" :loading="dataset.loading" :disabled="dataset.loading || habdivClosed"
                                @click.native="save">Salvar</v-btn>
                        </template>
                        <span>Salvar informações</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn class="ml-4" v-on="on" type="button" elevation="0" color="primary" outlined
                                to="/habilitacoes-divergencias">Voltar</v-btn>
                        </template>
                        <span>Retornar para habilitações e divergências</span>
                    </v-tooltip>
                </v-col>
            </v-row>

        </v-form>


        <!-- MODAIS -->

        <v-dialog v-model="showDocumentModal" max-width="800px">
            <v-card>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h1 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Escolha um
                                <span class="underline text-uppercase primary--text">documento</span>
                            </h1>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-card-text>
                    <v-btn class='mb-3' @click="openAddModalDocument(currentDocTypeId)" color="primary">
                        Novo documento
                    </v-btn>
                    <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header>Selecionar da Central de Documentos</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list dense v-if="!loadingDocuments">
                                    <v-list-item v-for="(doc, index) in documentsCenter" :key="index">
                                        <v-list-item-action>
                                            <v-checkbox v-model="doc.isSelected" :disabled="currentDocType !== 3 && currentDocType !== 4 &&
                                                !doc.isSelected && isAnyDocumentSelected">
                                            </v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>{{ doc.name }}</v-list-item-content>
                                        <v-list-item-content>{{ getDocTypeName(doc.type) }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-progress-circular v-else indeterminate></v-progress-circular>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-card-actions class='pa-0 mt-4'>
                        <v-btn color="primary" @click="confirmSelection">Confirmar</v-btn>
                        <v-btn @click="checkDocumentsBeforeClose" text>
                            Cancelar
                        </v-btn>
                        <!-- <v-btn color="error" @click="checkDocumentsBeforeClose">Fechar</v-btn> -->
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showAddDocumentModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h1 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Adicionar um
                                <span class="underline text-uppercase primary--text">documento</span>
                            </h1>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-form ref="formNewDocument" v-model="valid">
                    <!-- <v-card-text class='mt-1'>

                        <v-text-field outlined dense required :rules="[$rules.required]" v-model="newDocument.name"
                            label="Nome"></v-text-field>

                        <v-select :items="dataset.itemTypes" :rules="[$rules.required]" item-text="name" item-value="id"
                            v-model="newDocument.type" label="Tipo" outlined dense required></v-select>

                        <v-file-input outlined dense required prepend-icon="mdi-paperclip" :rules="[$rules.required]"
                            v-model='newDocument.file' label="Upload do Documento">
                        </v-file-input>

                    </v-card-text> -->

                    <v-card-text class='mt-1'>
                        <v-text-field outlined dense readonly :value="getDocTypeName(currentDocTypeId)"
                            label="Tipo de documento"></v-text-field>

                        <v-text-field outlined dense required :rules="[$rules.required]" v-model="newDocument.name"
                            label="Nome do documento"></v-text-field>

                        <v-file-input outlined dense required prepend-icon="mdi-paperclip" :rules="[$rules.required]"
                            v-model='newDocument.file' label="Selecionar documento" :accept="acceptedDocumentTypes"
                            show-size hint="PDF, imagem, planilha ou ZIP de até 1 GB" persistent-hint>
                        </v-file-input>
                        <v-progress-linear v-if="uploadProgress !== null" :value="uploadProgress" height="18" rounded class="mt-3">
                            <small>Enviando arquivo... {{ uploadProgress }}%</small>
                        </v-progress-linear>
                    </v-card-text>
                    <v-col sm='3' class="d-flex">
                        <v-btn @click="saveNewDocument" class='ml-auto' color="primary" block
                            :disabled="dataset.loading">
                            Enviar
                            <v-progress-circular v-if="dataset.loading" indeterminate color="white" size="20"
                                class="ml-2"></v-progress-circular>
                        </v-btn>
                        <v-btn class='ml-3' @click="closeAddDocumentsModal()" text>
                            Cancelar
                        </v-btn>
                    </v-col>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog max-width="800px" v-model="showConfirmationDialog">
            <v-card>
                <v-card-title>Confirmação</v-card-title>
                <v-card-text>Você possui documento(s) selecionado(s) que não foram salvos! Deseja sair sem salvar
                    suas alterações?</v-card-text>
                <v-card-actions>
                    <v-btn text @click="continueWithoutSaving">Não</v-btn>
                    <v-btn text @click="closeAlertModal">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAIS -->

        <v-row>
            <whatsButton />
        </v-row>

        <v-row>
            <topButton />
        </v-row>

    </section>
</template>

<script>
import 'moment/locale/pt-br';

import { eventHub } from '@/main';

import currencyTypes from '@/common/data/currency-types.data';
import topButton from '@/components/layout/GoToTopButton.vue';
import whatsButton from '@/components/layout/WhatsAppButton.vue';
import ProcuratorCreditorSelector from '@/components/ProcuratorCreditorSelector.vue';
import itemTypes from "@/common/data/item-types.data.js";
import creditorTypes from "@/common/data/creditor-types.data.js";
import statesList from "@/common/data/states-list.data";
import courtList from "@/common/data/court-types.data"


import { v4 as uuidv4 } from 'uuid';

import axios from 'axios';
import { needsChunkedUpload, chunkedUpload, validateDocumentFile, ACCEPTED_DOCUMENT_TYPES } from '@/common/util/chunked-upload';

export default {

    components: {
        topButton,
        whatsButton,
        ProcuratorCreditorSelector
    },

    data: () => ({
        user: null,
        selectedCreditorId: null,
        // Item completo do credor representado (traz o status da procuracao).
        selectedCreditor: null,
        valid: true,
        panel: [0],
        showConfirmationDialog: false,
        loadingDocuments: false,
        currentDocTypeName: '',
        dataset: {
            currencyTypes: currencyTypes,
            contentUserAnonymous: '',
            contentUserLogged: '',
            clients: [],
            selectedEventItem: -1,
            data: {
                items: [],
                actionProgress: false,
            },
            loading: false,
            itemTypes: itemTypes,
            creditorTypes: creditorTypes,
            statesList: statesList,
            courtList: courtList,
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            created: null
        },
        showDocumentModal: false,
        showAddDocumentModal: false,
        documentsCenter: [],
        newDocument: {},
        // Progresso do envio em partes pela API (arquivos grandes / ZIP).
        uploadProgress: null,
        acceptedDocumentTypes: ACCEPTED_DOCUMENT_TYPES,
        selectedPetitionDocument: null,
        selectedProcurationDocument: null,
        selectedSpreadsheet: null,
        selectSuportingDocument: [],
        selectOtherDocuments: [],
        currentDocTypeId: null,
        processes: [
            {
                number: '',
                local: '',
                court: '',
            }
        ],
    }),

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    mounted: function () { },

    computed: {
        isProcurator() {
            return !!this.user && Number(this.user.type) === 2;
        },

        isAnyDocumentSelected() {
            if (this.currentDocType === 'idOtherDocuments') {
                return false;
            }
            return this.documentsCenter.some(doc => doc.isSelected);
        },

	        // selectCreditorTypes() {

        //     console.log("client: ", dataset.data.client)
        //     if (this.isEventOpened) {
        //         return this.dataset.creditorTypes;
        //     } else {
        //         return this.dataset.creditorTypes.filter(type => type.id === 1);
        //     }
	        // }
	        // Caso escolhido fora do prazo de hab/div (antes ou depois): nao aceita pedido.
	        habdivClosed() {
	            const client = this.selectedClient;
	            return !!(client && client.is_event_opened !== true);
	        },

	        selectedClient() {
	            const clientId = typeof this.dataset.data.client === 'object'
	                ? this.dataset.data.client.id
	                : this.dataset.data.client;
	            return this.dataset.clients.find(item => item.id == clientId) || null;
	        },

	        debtorCompanyOptions() {
	            const client = this.selectedClient;
	            if (!client || !Array.isArray(client.companies) || client.companies.length === 0) return [];
	            // Consolidacao substancial: QGC unico do grupo, o credor nao precisa apontar a empresa.
	            if (Number(client.consolidation_type) === 2) return [];

	            const options = [];
	            const seen = new Set();
	            const addOption = (name) => {
	                const normalized = String(name || '').trim();
	                const key = normalized.toLowerCase();
	                if (!normalized || seen.has(key)) return;
	                seen.add(key);
	                options.push({ name: normalized });
	            };

	            addOption(client.name);
	            client.companies.forEach(company => addOption(company.name));

	            return options;
	        }
	    },


    watch: {
        'dataset.data.client'(value, oldValue) {
            if (String(value) === String(oldValue)) return;

            this.loadCreditorClasses(value);
        },
    },

    created() {
        this.selectedCreditorId = this.$route.query.creditor_user_id || null;

        if (this.$root.user) {
            this.loadUserInfo();
            this.loadClients();
        }

        this.loadText();

        if (this.$route.query.token) {
            this.verifyAccount(this.$route.query.token);
        }
    },

    methods: {

	        getDocTypeName(docTypeId) {
	            let docType = this.dataset.itemTypes.find(type => type.id === docTypeId);
	            return docType ? docType.name : 'Tipo Desconhecido';
	        },

	        onClientChange() {
	            this.dataset.data.items.forEach(item => {
	                this.$set(item, 'company_name', '');
	            });
	        },

        selectCreditorTypes() {

            const client_id = this.dataset.data.client

            let client = this.dataset.clients.find(item => item.id == client_id);

            // Desativado: com o edital fechado so a habilitacao trabalhista continuava aberta.
            // Depois do prazo o pedido fecha para todas as classes e o credito vem pela CHC.
            // if (client.is_event_opened === true) {
            //     return this.dataset.creditorTypes;
            // } else {
            //     // Edital fechado: apenas habilitacao trabalhista continua aberta.
            //     return this.dataset.creditorTypes.filter(type => Number(type.id) === 1);
            // }
            return client ? this.dataset.creditorTypes : [];
        },

        async loadCreditorClasses(clientId) {
            if (!clientId) return;

            try {
                const result = await axios.get(`/api/clients/${clientId}/creditor-classes`);
                const data = (result.data.content && result.data.content.data) || [];

                if (!data.length) return;

                this.dataset.creditorTypes = data.map((item) => ({
                    id: item.legacy_class_id,
                    name: item.name,
                }));
            } catch (error) {
                // Mantem as classes padrao importadas do arquivo local.
            }
        },

        checkDocumentsBeforeClose() {
            if (this.documentsCenter.some(doc => doc.isSelected)) {
                this.showConfirmationDialog = true;
            } else {
                this.closeModal();
            }
        },

        clearDocs(index, type) {

            const field = this.dataset.data.items[index].docs ? 'docs' : 'files';
            const filteredDocs = this.dataset.data.items[index][field].filter((x) => x.type != type)

            // this.dataset.data.items[index].docs = this.dataset.data.items[index].docs.filter(doc => doc.type !== type);]

            console.log(index, filteredDocs)

            this.dataset.data.items[index][field] = filteredDocs

            return true;
        },

        addProcess() {
            if (this.processes.length < 10) {
                this.processes.push({
                    number: '',
                    local: '',
                    court: '',
                });
            }
        },
   
        removeProcess(index) {
            if (this.processes.length > 1) {
                this.processes.splice(index, 1);
            }
        },

        closeAddDocumentsModal() {

            this.newDocument.name = null;
            this.newDocument.file = null;

            this.showAddDocumentModal = false;
        },

        closeAlertModal() {
            this.showConfirmationDialog = false;
            this.closeModal();
        },
        continueWithoutSaving() {
            this.showConfirmationDialog = false;
        },
        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },

        getDocsByType(index, type) {

            const result = this.dataset.data.items[index].files.filter((x) => x.type == type).map((x) => x.name).join("; ");

            console.log("Valor retornado: ", result);

            return result;
        },

        // getDocsByType(index, type) {

        //     console.log("Index: ", index, "type: ", type)

        //     return this.dataset.data.items[index].files.filter((x) => x.type == type).map((x) => x.name).join("; ");
        // },

        // hasDocument(index, step) {
        //     const item = this.dataset.data.items[index];

        //     // const fieldName = `file${step}`;
        //     // const fileUploaded = item[fieldName] && item[fieldName].length > 0;

        //     let documentSelected = false;

        //     if (step === 1) {
        //         documentSelected = !!item.type;
        //     }
        //     if (step === 2) {
        //         documentSelected = this.selectedPetitionDocument != null;
        //     }
        //     if (step === 3) {
        //         documentSelected = this.selectedProcurationDocument != null;
        //     }
        //     if (step === 4) {
        //         documentSelected = this.selectedSpreadsheet != null;
        //     }
        //     if (step === 5) {
        //         return this.selectSuportingDocument.length > 0;
        //     }
        //     if (step === 6) {
        //         return this.selectOtherDocuments.length > 0;
        //     }

        //     return documentSelected;
        // },

        hasDocument(index, type, required) {
            if (!required) return true;

            const items = this.dataset.data.items[index].files.filter((x) => x.type == type);

            return items.length > 0;
        },



        onCancel(index, step) {
            if (step > 1) {
                this.dataset.data.items[index].step = step - 1;
            }

            switch (step) {
                case 2:
                    this.selectedPetitionDocument = null;
                    this.selectedProcurationDocument = null;
                    this.dataset.data.items.file1 = null;
                    this.dataset.data.items.file2 = null;


                    break;
                case 3:
                    this.selectedProcurationDocument = null;
                    this.selectedSpreadsheet = null;
                    this.dataset.data.items.file2 = null;
                    this.dataset.data.items.file3 = null;
                    break;
                case 4:
                    this.selectedSpreadsheet = null;
                    this.selectSuportingDocument = [];
                    this.dataset.data.items.file3 = null;
                    this.dataset.data.items.file4 = [];

                    break;
                case 5:
                    this.selectSuportingDocument = [];
                    this.selectOtherDocuments = [];
                    this.dataset.data.items.file4 = [];
                    this.dataset.data.items.file5 = [];

                    break;
            }

        },

        getItemNumber(i) {
            return i + 1;
        },

        onInput(index, step) {
            if (!this.dataset.data.items[index].step) this.dataset.data.items[index].step = 1;

            if (this.hasDocument(index, step)) {
                this.dataset.data.items[index].step = step + 1;
            } else {
                this.$dialog.notify.error('Selecione um documento antes de continuar', {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadText() {
            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'create-user-event-anonymous,create-user-event-logged' }
                });

                if (!result.data.content) return;

                let contentUserAnonymous = result.data.content.find(
                    (x) => x.key === 'create-user-event-anonymous'
                );
                let contentUserLogged = result.data.content.find(
                    (x) => x.key === 'create-user-event-logged'
                );

                this.dataset.contentUserAnonymous = contentUserAnonymous
                    ? contentUserAnonymous.value
                    : '';
                this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : '';
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { limit: 100000 } });

                if (!result.data.content.data) return;

                this.dataset.clients = result.data.content.data.filter(
                    client => (client.portal_habdiv_enabled === undefined
                ? (client.creditor_portal_enabled === undefined || Number(client.creditor_portal_enabled) !== 0)
                : Number(client.portal_habdiv_enabled) !== 0)
                );
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadUserInfo() {
            this.dataset.loading = true;

            try {
                const result = await axios.get('/api/users/info');

                this.user = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        async load() {
            this.dataset.loading = true;

            try {
                const result = await axios.get('/api/user-events/request');

                this.data = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        // onFileSelected(files, step, index) {
        //     this.dataset.data.items[index][`file${step}`] = files;
        // },

        // validateFormItems() {
        //     if (!this.dataset.data.items.length) return false;

        //     for (let item of this.dataset.data.items) {
        //         if (!item.origin || !item.amount || !item.currency) {
        //             return false;
        //         }

        //         if (!item.file1 || !item.file2 || !item.file3) {
        //             return false;
        //         }

        //         if ((Array.isArray(item.file4) && item.file4.length === 0) ||
        //             (Array.isArray(item.file5) && item.file5.length === 0)) {
        //             return false;
        //         }
        //     }
        //     return true;
        // },



        validateFormItems() {
            if (!this.dataset.data.items.length) return false;

            for (let item of this.dataset.data.items) {
                if (!item.origin || !item.amount || !item.currency) {
                    return false;
                }

                if (!item.type || (Array.isArray(item.file4) && item.file4.length === 0)) {
                    return false;
                }
            }
            return true;
        },


        onCreditorSelected(item) {
            this.selectedCreditor = item || null;
        },

        async save() {

            if (this.dataset.loading) return;

            if (this.habdivClosed) {
                this.$dialog.notify.error('O prazo de habilitação e divergência deste caso não está aberto.', {
                    position: 'top-right',
                    timeout: 3000
                });
                return;
            }

            if (this.isProcurator && !this.selectedCreditorId) {
                this.$dialog.notify.error('Selecione o credor representado antes de enviar.', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            if (!this.$refs.form.validate()) {

                this.$dialog.notify.error(
                    'Preencha as informações obrigatórias de um negócio antes de continuar',
                    {
                        position: 'top-right',
                        timeout: 2000
                    }
                );
                return;
            }


            if (!this.dataset.data.items.length) {
                this.$dialog.notify.error(
                    'Preencha as informações de um negócio antes de continuar',
                    {
                        position: 'top-right',
                        timeout: 2000
                    }
                );
                return;
            }

            if (!this.validateFormItems()) {
                this.$dialog.notify.error('Preencha todos os campos antes de continuar', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            if (this.dataset.data.actionProgress) { 
      
                const result = this.validateFormProcess()

                if (!result) {
                    this.$dialog.notify.error('Preencha todos os campos de um processo antes de continuar', { position: 'top-right', timeout: 2000 });
                            
                    return;
                }
            }

            this.dataset.loading = true;

            try {
                if (this.isProcurator && this.selectedCreditor && Number(this.selectedCreditor.status) === 0) {
                    const acknowledged = await this.$dialog.confirm({
                        title: 'Procuração em análise',
                        text: 'Atenção: a procuração apresentada em nome do credor ainda não foi analisada pela Administração Judicial. A apreciação deste pedido está condicionada à regularidade da representação. Caso seja solicitada complementação documental, a irregularidade deverá ser sanada no prazo de 72 horas, sob pena de o pedido e os demais atos praticados em nome do credor serem desconsiderados.',
                        actions: {
                            false: 'Cancelar',
                            true: 'Estou ciente'
                        }
                    });

                    if (!acknowledged) return;
                }

                const proceedAction = await this.$dialog.confirm({
                    text: 'Deseja concluir o formulário?',
                    title: 'Finalizar',
                    actions: {
                        false: 'Cancelar',
                        true: 'Concluir'
                    }
                });

                if (!proceedAction) return;

                const payload = this.buildPayload();

                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const response = await axios.post('/api/user-events/request', payload);

                await this.$dialog.confirm({
                    text: 'Informações enviadas com sucesso! Você receberá um e-mail assim que sua solicitação for analisada.',
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                });

                this.dataset.data = { items: [] };

                this.$router.replace('/habilitacoes-divergencias');
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.loading = false;
            }
        },


	        buildPayload() {
	            let payload = {
                client_id: this.dataset.data.client,
                processes: this.dataset.data.actionProgress ? this.processes : [],
                items: []
            };

            if (this.selectedCreditorId) payload.creditor_user_id = this.selectedCreditorId;

            for (let item of this.dataset.data.items) {

	                let itemData = {
	                    currency: item.currency,
	                    origin: item.origin,
	                    amount: item.amount,
	                    observation: item.observation,
	                    type: item.type,
	                    company_name: item.company_name || '',
	                    files: []
	                };

                for (let file of item.files) {
                    itemData.files.push(file.id);
                }

                payload.items.push(itemData);
            }

            return payload

        },

        validateFormProcess() {
            if (!this.processes.length) return false;

            for (let item of this.processes) {
                if (!item.number || !item.local ) {
                    return false;
                }

            }

            return true;
        },

        // buildPayload() {
        //     const formData = new FormData();

        //     formData.append('client_id', this.dataset.data.client);

        //     const transformedItems = this.dataset.data.items.map(item => {
        //         const files = [];

        //         if (item.file1) files.push(item.file1);
        //         if (item.file2) files.push(item.file2);
        //         if (item.file3) files.push(item.file3);
        //         if (item.file4) files.push(item.file4);

        //         if (Array.isArray(item.file5)) {
        //             item.file5.forEach(fileId => {
        //                 files.push(fileId);
        //             });
        //         }

        //         return {
        //             currency: item.currency,
        //             origin: item.origin,
        //             amount: item.amount,
        //             observation: item.observation,
        //             files
        //         };
        //     });

        //     formData.append('items', JSON.stringify(transformedItems));

        //     return formData;
        // },




        // buildPayload() {
        //     const formData = new FormData();

        //     formData.append('client_id', this.dataset.data.client);

        //     //TODO: Melhorar lógica de atribuição dos documentos

        //     for (let item of this.dataset.data.items) {
        //         const refFiles = [];

        //         for (let file of item.file1) {
        //             const key = uuidv4();
        //             refFiles.push({ key, type: 1 });
        //             formData.append('files[]', file, key);
        //         }

        //         for (let file of item.file2) {
        //            
        //         }

        //         for (let file of item.file3) {
        //             const key = uuidv4();
        //             refFiles.push({ key, type: 3 });
        //             formData.append('files[]', file, key);
        //         }

        //         for (let file of item.file4) {
        //             const key = uuidv4();
        //             refFiles.push({ key, type: 4 });
        //             formData.append('files[]', file, key);
        //         }
        //         for (let file of item.file5) {
        //             const key = uuidv4();
        //             refFiles.push({ key, type: 5 });
        //             formData.append('files[]', file, key);
        //         }


        //         item.refFiles = refFiles;
        //     }

        //     formData.append('items', JSON.stringify(this.dataset.data.items));

        //     console.log(formData)

        //     return formData;
        // },

	        addItem() {
	            this.dataset.data.items.push({
	                currency: 1,
	                step: 1,
	                company_name: '',
	                files: []
	            });
	        },

        removeItem(index) {
            this.dataset.data.items.splice(index, 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },


        // UP DOC

        confirmSelection() {

            const selectedDocs = this.documentsCenter.filter(doc => doc.isSelected);

            console.log('selected docs ', selectedDocs);

            const files = this.dataset.data.items[this.dataset.selectedEventItem].files;

            this.dataset.data.items[this.dataset.selectedEventItem].files = files.concat(selectedDocs);

            this.closeModal();
        },

        closeModal() {
            this.showDocumentModal = false;
            this.newFile = null;
            this.documentsCenter.forEach(doc => doc.selected = false);
        },

        closeAddModalDocument() {
            this.showAddDocumentModal = false;
        },

        openAddModalDocument(docTypeId) {
            this.currentDocTypeId = docTypeId;
            this.currentDocTypeName = this.getDocTypeName(docTypeId);
            this.showAddDocumentModal = true;
        },

        openDocumentModal(index, type) {
            this.currentDocType = type;

            this.dataset.selectedEventItem = index;

            this.currentDocTypeId = type;

            this.dataset.selectedEventItem = index;

            this.loadingDocuments = true;

            this.getDocuments(type).finally(() => {
                this.loadingDocuments = false;
                this.showDocumentModal = true;
            });
        },


        async getDocuments(docTypeId) {

            this.loadingDocuments = true;

            try {
                const response = await axios.get(`/api/user-docs`, {
                    params: { start: 0, limit: 1000, search: { "type": docTypeId } }
                });

                if (response.data && response.data.status && response.data.content) {

                    this.documentsCenter = response.data.content.data.map(doc => {

                        const docType = this.dataset.itemTypes.find(type => type.id === doc.type);

                        return {
                            isSelected: false,
                            name: doc.name,
                            // type: docType ? docType.name : '',
                            type: doc.type,
                            created_at: doc.created_at,
                            file_url: doc.file_url,
                            id: doc.id

                        };
                    }).sort((a, b) => {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });
                }


            } catch (error) {
                console.error("Erro ao obter documentos", error);
            } finally {
                this.loadingDocuments = false;
            }
        },

        async saveNewDocument() {
            if (this.dataset.loading) return;
            if (!this.$refs.formNewDocument.validate()) return;

            const fileError = validateDocumentFile(this.newDocument.file);
            if (fileError) {
                this.$dialog.notify.error(fileError, { position: 'top-right', timeout: 5000 });
                return;
            }

            this.dataset.loading = true;

            try {
                if (needsChunkedUpload(this.newDocument.file)) {
                    // Arquivo grande ou ZIP: vai em partes pela API e o registro recebe so a chave.
                    this.uploadProgress = 0;
                    const uploaded = await chunkedUpload(this.newDocument.file, {
                        onProgress: (percent) => { this.uploadProgress = percent; },
                    });
                    await axios.post('/api/user-docs', {
                        name: this.newDocument.name,
                        type: this.currentDocTypeId,
                        uploaded_key: uploaded.key,
                        uploaded_name: uploaded.name,
                    });
                } else {
                    let formData = new FormData();

                    formData.append('name', this.newDocument.name);
                    formData.append('type', this.currentDocTypeId);
                    formData.append('file', this.newDocument.file);

                    await axios.post('/api/user-docs', formData);
                }

                await this.getDocuments(this.currentDocTypeId);
                this.closeAddModalDocument();

                this.newDocument = [];

                this.$dialog.notify.success("Documento salvo com sucesso", { position: 'top-right', timeout: 5000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes ? this.$codes(error) : "Erro ao salvar o documento", { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
                this.uploadProgress = null;
            }
        },
    },


};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-family: 'Raleway';
    font-size: 14px;
    font-style: normal;
}

.custom-modal-title {
    font-size: 20px;

    @media (max-width: 600px) {
        font-size: 14px;
    }
}
</style>
